import gql from 'graphql-tag'
export const ADD_PROGRESS = gql`
  mutation adicionaProgresso($cursoId: String!, $conteudoId: String!) {
    adicionaProgresso(cursoId: $cursoId, conteudoId: $conteudoId) {
      conteudo_id,
      progresso
    }
  }
`

export const ADD_LAST_VISITED = gql`
  mutation atualizaUltimoConteudoVisitado($cursoId: String!, $conteudoId: String!) {
    atualizaUltimoConteudoVisitado(cursoId: $cursoId, conteudoId: $conteudoId)
  }
`

export const ANSWER_QUIZ_QUESTION = gql`
  mutation respondePerguntaQuiz($cursoId: String!, $conteudoId: String!, $perguntaId: String!, $respostaId: String!) {
    respondePerguntaQuiz(cursoId: $cursoId, conteudoId: $conteudoId, perguntaId: $perguntaId, respostaId: $respostaId)
    {
      comentario,
      certa
    }
  }
`